module.exports = __webpack_public_path__ + "img/sw5e-logo.84b4d7ed.png";